import Amap from '@/common/components/AMap';
import { isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { FC, forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import styles from './index.module.less';

const PPTMap:FC<any> = forwardRef(({
  height,
  lnglat,
  range,
  massData,
  onMapReady,
  poiName
}, ref) => {
  const mapIns: any = useRef(); // 地图实例

  useImperativeHandle(ref, () => ({
    mapIns: mapIns.current, // 地图实例
    addMassMarker: methods.addMassMarker, // 添加兴趣点
    addMarkerCircle: methods.addMarkerCircle, // 添加带点圆圈
    addCircle: methods.addCircle, // 添加圆圈
  }));

  const methods = useMethods({
    mapLoadedHandle(map) {
      mapIns.current = map;
      onMapReady?.(mapIns);
    },
    addMassMarker(massData?: any) {
      const data = massData.map((item) => {
        return { ...item, lnglat: [item.lng, item.lat] };
      });
      const mass = new window.AMap.MassMarks(data, {
        opacity: 0.8,
        zIndex: 111,
        cursor: 'pointer',
        style: {
          url: 'https://staticres.linhuiba.com/project-custom/location-space-mp/icon/massive_points.png',
          size: [16, 16]
        }
      });

      mass.setMap(mapIns.current);

      mapIns.current?.add(mass);
    },
    addMarkerCircle(lng, lat, range, recommendRange) {
      // 构造点标记
      let marker;
      if (recommendRange) {
        marker = new window.AMap.Marker({
          content: `
            <div class=${styles['content']}>
              <div class=${styles['box']}>
                <div class=${styles['title']}>${poiName || '-'}</div>
                <div class=${styles['divider']}></div>
                <div class=${styles['range']}>${recommendRange}m</div>
              </div>
            </div>
          `,
          position: [lng, lat],
          offset: new window.AMap.Pixel(0, 20)
        });
      } else {
        marker = new window.AMap.Marker({
          icon: new window.AMap.Icon({
            // 图标尺寸
            size: new window.AMap.Size(50, 50),
            // 图标的取图地址
            image: require('@/assets/image/loc_icon.png'),
            // 图标所用图片大小
            imageSize: new window.AMap.Size(50, 50),
          }),
          position: [lng, lat],
          offset: new window.AMap.Pixel(-25, -25)
        });
      }
      // 构造矢量圆形
      const circle = new window.AMap.Circle({
        center: new window.AMap.LngLat(lng, lat), // 圆心位置
        radius: range, // 半径
        strokeColor: recommendRange ? '#FF861D' : '#006AFF', // 线颜色
        strokeOpacity: 1, // 线透明度
        strokeWeight: 3, // 线粗细度
        fillColor: recommendRange ? 'rgba(252,138,40,0.18)' : 'rgba(0,106,255,0.18)', // 填充颜色
        fillOpacity: 0.35 // 填充透明度
      });
      // 将以上覆盖物添加到地图上
      // 单独将点标记添加到地图上
      // map.add(marker);
      // add方法可以传入一个覆盖物数组，将点标记和矢量圆同时添加到地图上
      mapIns.current?.add([marker, circle]);
      mapIns.current?.setFitView(circle);
    },
    addCircle(lng, lat, range) {
      // 构造矢量圆形
      const circle = new window.AMap.Circle({
        center: new window.AMap.LngLat(lng, lat), // 圆心位置
        radius: range, // 半径
        strokeColor: '#006AFF', // 线颜色
        strokeOpacity: 1, // 线透明度
        strokeWeight: 3, // 线粗细度
        fillColor: 'rgba(0,106,255,0.18)', // 填充颜色
        fillOpacity: 0.35 // 填充透明度
      });
      mapIns.current?.add([circle]);
    }
  });

  useEffect(() => {
    if (isNotEmptyAny(lnglat) && isNotEmptyAny(range) && mapIns.current) {
      methods.addMarkerCircle(lnglat?.lng, lnglat?.lat, range);
    }
  }, [lnglat, mapIns, range]);

  useEffect(() => {
    if (isNotEmptyAny(massData) && mapIns.current) {
      methods.addMassMarker(massData);
    }
  }, [massData, mapIns]);

  return (
    <div style={{ width: '100%', height }}>
      <Amap
        loaded={methods.mapLoadedHandle}
        styleOpt={{ borderRadius: 12 }}
        mapOpts={{
          // zoom:11,//级别
          center: [120.298501, 30.41875], // 中心点坐标
          // viewMode:'3D'//使用3D视图
          WebGLParams: { preserveDrawingBuffer: true }
        }}/>
    </div>
  );
});

export default PPTMap;
